/**
 * Gera slug amigável a partir do nome (mesma lógica do backend).
 * Ex: "Arretados do Volei" -> "arretados-do-volei"
 */
export function generateSlugFromName(name: string): string {
  const normalized = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return normalized || "time";
}

/**
 * Retorna o path da URL do time. Usa slug quando disponível para URLs amigáveis.
 * Aceita slug ou id - o backend resolve ambos.
 */
export function getTeamPath(
  team: { id: string; slug?: string } | string,
  subPath?: string,
): string {
  const identifier =
    typeof team === 'string' ? team : (team.slug ?? team.id);
  const base = `/teams/${identifier}`;
  return subPath ? `${base}/${subPath}` : base;
}
